module.exports = __webpack_public_path__ + "img/program-experience.885b1d48.jpg";